import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import DrawerHeaderStyled from './DrawerHeaderStyled';
import { Box, Typography, Stack } from '@mui/material';
import LogoMain from 'components/logo/LogoMain';
import LogoIcon from 'components/logo/LogoIcon';

export default function DrawerHeader({ open }) {
  return (
    <DrawerHeaderStyled
      open={open}
      sx={{ minHeight: '60px', width: 'initial', px: open ? 3 : 0, py: 1, justifyContent: open ? 'flex-start' : 'center' }}
    >
      <Box component={Link} to="/" sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none', gap: 1.5 }}>
        {open ? (
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Box sx={{ borderRadius: 1, overflow: 'hidden', flexShrink: 0 }}>
              <LogoMain />
            </Box>
            <Box>
              <Typography variant="subtitle1" fontWeight={700} sx={{ color: '#004225' }} lineHeight={1.2}>
                Cashflow App
              </Typography>
              <Typography variant="caption" sx={{ color: '#004225' }} lineHeight={1}>
                Controle financeiro
              </Typography>
            </Box>
          </Stack>
        ) : (
          <Box sx={{ borderRadius: 1, overflow: 'hidden' }}>
            <LogoIcon />
          </Box>
        )}
      </Box>
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
